@let val = value();
<app-spinner [loading]="isLoadingKeys() || isDeletingKey()"></app-spinner>
<section class="crypto-token-details">
  <h1 class="crypto-token-details__header">{{title()}}</h1>
  <div>
    <button mat-button type="button" class="button" (click)="onBack()">{{labels.back}}</button>
  </div>
  @if (val) {
    <div class="crypto-token-details__body">
      <div class="crypto-token-details__key crypto-token-details_top crypto-token-details_top-left">
        {{labels.properties.tokenName}}
      </div>
      <div class="crypto-token-details__value crypto-token-details_top crypto-token-details_top-right">
        {{val.tokenName || labels.na}}
      </div>
      <div class="crypto-token-details__key">
        {{labels.properties.tokenType}}
      </div>
      <div class="crypto-token-details__value">
        {{val.tokenType || labels.na}}
      </div>
      <div class="crypto-token-details__key">
        {{labels.properties.autoActivation}}
      </div>
      <div class="crypto-token-details__value">
        @if(val.autoActivation) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        }
        @else if(!val.autoActivation) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        }
        @else {
          {{labels.na}}
        }
      </div>
      <div class="crypto-token-details__key crypto-token-details_bottom-left">
        {{labels.properties.active}}
      </div>
      <div class="crypto-token-details__value crypto-token-details_bottom-right">
        @if(val.active) {
          <svg-icon icon="checkbox-checked"></svg-icon>
        }
        @else if(!val.active) {
          <svg-icon icon="checkbox-unchecked"></svg-icon>
        }
        @else {
          {{labels.na}}
        }
      </div>
    </div>
  }
  @if(isEditor()) {
    <app-create-crypto-token-key [value]="val"></app-create-crypto-token-key>
  }
  <app-table paginationEnabled="false" domLayout="autoHeight" [columnDefs]="columnDefs()" [rowData]="rowData()" [gridOptions]="{}"></app-table>
</section>



